import { useResourceFormQuery } from "src/components/Form/hooks/useResourceFormQuery.ts";

export const useResourceFormData = <Data = any>() => {
  const { data } = useResourceFormQuery();
  return data as unknown as Data | undefined;
};
